// frontend/src/pages/Register.jsx
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './Auth.css';
import fullLogo from '../assets/branding/abogados_quiroz_logo_exact.svg';

const Register = () => {
  const [nombre, setNombre] = useState('');
  const [apellido, setApellido] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [registerError, setRegisterError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { register } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setRegisterError(null);

    if (password !== confirmPassword) {
      setRegisterError('Las contraseñas no coinciden');
      return;
    }

    if (password.length < 6) {
      setRegisterError('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    setIsLoading(true);
    
    const result = await register(nombre, apellido, email, password);
    
    setIsLoading(false);
    
    if (result.success) {
      setSuccess(true);
      setTimeout(() => {
        window.location.href = '/login';
      }, 2000);
    } else {
      setRegisterError(result.error);
    }
  };

  if (success) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <img className="auth-inline-logo" src={fullLogo} alt="Abogados Quiroz" />
            <h1>¡Registro Exitoso!</h1>
            <p>Tu cuenta ha sido creada correctamente</p>
            <p style={{ color: '#7f8c8d', fontSize: '14px' }}>
              Serás redirigido al inicio de sesión...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img className="auth-inline-logo" src={fullLogo} alt="Abogados Quiroz" />
          <h1>Abogados Quiroz</h1>
          <p>Crear Cuenta</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {registerError && (
            <div className="auth-error">
              <span>⚠️</span> {registerError}
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label>Nombre *</label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                placeholder="Juan"
                required
              />
            </div>
            <div className="form-group">
              <label>Apellido *</label>
              <input
                type="text"
                value={apellido}
                onChange={(e) => setApellido(e.target.value)}
                placeholder="Pérez"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="tu@email.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Contraseña *</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
              required
            />
          </div>

          <div className="form-group">
            <label>Confirmar Contraseña *</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder="Repite tu contraseña"
              required
            />
          </div>

          <button type="submit" className="btn-auth" disabled={isLoading}>
            {isLoading ? 'Registrando...' : 'Registrarse'}
          </button>

          <p className="auth-link">
            ¿Ya tienes cuenta? <a href="/login">Inicia sesión aquí</a>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Register;
